<template>
  <div id="chatCall" class="height100 m-r-12">
    <div class="border">
      <v-row>
        <v-col
          cols="12"
          sm="12"
          md="12"
          lg="12"
          class="d-flex p-t-0 p-b-0 no-select"
          @click.shift.left="handleSessionLog"
        >
          <div class="m-auto m-l-15">Conversation</div>
          <v-spacer></v-spacer>
          <v-icon small right class="mr-2" @click="close">
            fa-times
          </v-icon>
        </v-col>
      </v-row>
    </div>
    <div class="chat-panel borderTop0">
      <div id="chat-container" class="chat-container">
        <Conversation
          :sessionId="chatDetail.session_id"
          :conversations="conversations"
          :action="chatDetail.action"
          :isEndSession="chatDetail.is_end_session"
          :channel="chatDetail.channel"
          :customer="chatDetail.customers"
        />
      </div>
    </div>

    <v-snackbar
      v-model="snackbar.open"
      :color="snackbar.colorSnackbar"
      :timeout="3000"
      :top="true"
      :vertical="true"
    >
      {{ snackbar.textSnackbar }}

      <template v-slot:action="{ attrs }">
        <v-btn dark text v-bind="attrs" @click="snackbar.open = false">
          Close
        </v-btn>
      </template>
    </v-snackbar>
  </div>
</template>

<script>
import _ from 'lodash'

// import apiUser from '@/apis/user'

import Conversation from '@/components/conversation/index'

export default {
  components: {
    Conversation
  },
  props: {
    botSessionId: String,
    chatDetail: Object
  },
  data() {
    return {
      conversations: [],
      snackbar: {
        open: false,
        colorSnackbar: '',
        textSnackbar: ''
      }
    }
  },
  watch: {
    chatDetail: {
      deep: true,
      immediate: true,
      handler(newValue) {
        if (this.chatDetail.action_transfer) {
          for (const transfer of this.chatDetail.action_transfer) {
            transfer.message = { message_type: 'action' }
          }
          this.conversations = [
            ...this.chatDetail.conversations,
            ...this.chatDetail.action_transfer
          ]

          this.conversations = _.sortBy(this.conversations, [
            function(o) {
              return o.created_at
            }
          ])
        } else this.conversations = this.chatDetail.conversations || []
      }
    }
  },

  methods: {
    close() {
      this.$emit('close', null)
    },
    handleSessionLog() {
      if (this.botSessionId)
        setTimeout(() => {
          const routeData = this.$router.resolve({
            name: 'SessionLog',
            query: { id: this.botSessionId }
          })
          window.open(routeData.href, '_blank')
        }, 100)
      else {
        {
          this.snackbar.colorSnackbar = 'error'
          this.snackbar.textSnackbar = 'bot_session_id is required'
          this.snackbar.open = true
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.border {
  background-color: $table-header;
  padding: 5px;
}
.no-select {
  height: 36px;
}

.borderTop0 {
  border: none;
  height: calc(100vh - 122px);
  max-height: calc(100vh - 122px);
  min-height: calc(100vh - 122px);
}
</style>
